<!--
 - Author : wanghongling.
 - Date   : 2019/7/12.
 - File   : energy.总能耗新版本2.0
 -->

<template>
  <div class="energy-wrap">
    <layer title="总能耗" width="440px" padding="8px 20px">
      <div class="energy">
        <div class="energy-item" @click="showMsg(energy24Obj, 0)">
          <div class="energy-item-left">
            <img class="img-zindex" src="../../assets/images/shitang/sd1.gif" alt="">
            <div class="sd-ct">
              <img src="../../assets/images/shitang/lightning.png" alt="">
            </div>
          </div>
          <div class="energy-item-right">
            <p>日用电量</p>
            <p class="white fz18">{{energyObj.energyConsumption}} <span class="fz12">KWh</span></p>
            <p>当前功率</p>
            <p class="white fz18">{{energyObj.power}} <span class="fz12">w</span></p>
          </div>
        </div>
        <div class="energy-item" @click="showMsg(water24obj, 1)">
          <div class="energy-item-left">
            <liquid-fill id="waterFill" :liquid-list="safeFillData" :showCicrle="false"></liquid-fill>
          </div>
          <div class="energy-item-right">
            <p>日耗水量</p>
            <p class="white fz18">{{water24obj.todayWater||0}} <span class="fz12">t</span></p>
            <p>昨日水耗</p>
            <p class="white fz18">{{water24obj.yesterdayWater||0}} <span class="fz12">t</span></p>
          </div>
        </div>
      </div>
    </layer>
    <transition name="slide-left-fade">
      <datePopover :title="showType===0?'用电总能耗':'用水总能耗'"
          width="1200px"
          v-if="showEnergyTag"
          :aqiMsg="currentPos"
          class="wave-bar1"
          @selectTimeFn="changeTime"
          @closeEvent="showEnergyTag=false">
        <div style="display: flex; justify-content: space-between;">
          <div class="wave-class" v-if="showType===0">
            <div class="gl">
              <div class="gl-left"><span>日耗电量</span><span>{{currentPos.currTotalEnergyConsumption||'暂无'}}kWh</span> </div>
              <div class="gl-left"><span>当前功率</span><span>{{currentPos.currPower||'暂无'}}w</span> </div>
              <div class="gl-right"><span>读取时间</span><span>{{currentPos.currDate||'暂无'}}</span> </div>
            </div>
            <wave-bar :id="'line'+Math.random()" :waveList="energyList"></wave-bar>
          </div>
          <div class="wave-class" v-if="showType===1">
            <div class="gl">
              <div class="gl-left"><span>日耗水量</span><span>{{currentPos.todayWater||'暂无'}}t</span> </div>
              <div class="gl-left"><span>昨日水耗</span><span>{{currentPos.yesterdayWater||'暂无'}}t</span> </div>
              <div class="gl-right"><span>读取时间</span><span>{{currentPos.currDate||'暂无'}}</span> </div>
            </div>
            <wave-bar :id="'water'+Math.random()" :waveList="waveList"></wave-bar>
          </div>
          <ul class="open-his1">
            <li class="his-title">异常告警</li>
            <div style="min-height: 234px" v-show="exceptionList&&exceptionList.length>0">
              <li class="li" v-for="(item, index) in exceptionList" :key="index">
                <span class="li-left">{{item.occurrenceTime||'暂无'}}</span>
                <span class="li-right">{{item.deviceName}}{{item.content}}</span>
              </li>
            </div>
            <li class="no-his-data1" v-show="exceptionList&&exceptionList.length===0">暂无异常告警</li>
            <el-pagination
                background
                small
                :current-page="page"
                :page-size="pageSize"
                @current-change="pageChange"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>
          </ul>
        </div>
      </datePopover>
    </transition>
  </div>
</template>

<script>
  import dayjs from 'dayjs'
  export default {
    name: 'energy',
    data () {
      return {
        deptId: this.$route.query.deptId,
        safeFillData: {
          date: -1,
          width: '60px',
          height: '60px',
          margin: '30px 23px',
          radius: '100%',
          bgColor: 'rgba(0,157,159,0.1)',
          borderColor: '#02536e',
          shadowColor: '#05575f',
          theTop: '80px',
          shape: 'path://M448.184 101.451c-0.903-7.267-12.85-7.267-13.754 0-29.928 241.246-182.938 290.943-182.938 458.589 0 103.601 86.891 187.578 189.835 187.578 102.904 0 189.796-83.978 189.796-187.578 0-167.646-153.011-217.343-182.939-458.589z m32.331 602.066c-10.778 0-19.46-8.704-19.46-19.461 0-10.756 8.723-19.46 19.46-19.46 26.809 0 48.61-21.719 48.61-48.465 0-10.757 8.702-19.46 19.46-19.46a19.46 19.46 0 0 1 17.94 11.823 19.285 19.285 0 0 1 1.56 7.637c0 48.198-39.29 87.386-87.57 87.386zM686.584 182.662c-0.321-2.58-4.563-2.58-4.883 0-10.626 85.654-64.952 103.298-64.952 162.82 0 36.783 30.85 66.599 67.4 66.599 36.536 0 67.386-29.816 67.386-66.599 0.001-59.522-54.325-77.167-64.951-162.82z m11.479 213.761a6.9 6.9 0 0 1-6.909-6.91 6.91 6.91 0 0 1 6.909-6.909c9.518 0 17.259-7.711 17.259-17.207a6.905 6.905 0 0 1 6.909-6.909 6.91 6.91 0 0 1 6.924 6.909c-0.001 17.112-13.95 31.026-31.092 31.026zM898.247 790.223c-14.688-6.216-31.634 0.65-37.851 15.338-16.46 38.884-54.66 64.682-97.613 64.682-43.511 0-82.097-26.461-98.17-66.073-5.997-14.781-22.839-21.9-37.617-15.904a28.722 28.722 0 0 0-13.197 10.808c-1.543 1.969-2.939 4.084-3.961 6.499-16.431 38.872-54.623 64.67-97.579 64.67-42.487 0-80.132-25.316-96.867-63.382-2.331-8.356-8.277-15.607-16.947-19.091-14.799-5.948-31.616 1.228-37.563 16.027-16.003 39.822-54.682 66.446-98.336 66.446-43.969 0-82.882-27.032-98.647-67.278-5.817-14.851-22.572-22.175-37.422-16.358-14.851 5.817-22.174 22.572-16.357 37.423C134.486 886.228 194.612 928 262.546 928c49.3 0 94.436-22.055 124.844-57.923C417.801 905.954 462.959 928 512.259 928c49.482 0 94.866-22.185 125.287-58.364C667.953 905.774 713.283 928 762.783 928c66.355 0 125.377-39.86 150.801-99.926 6.217-14.687-0.65-31.634-15.337-37.851z',
          text: '',
          label: {
            normal: {
              formatter: function () {
                return ''
              }
            }
          },
          colorList: ['rgba(14,197,210,1)', 'rgba(13,165,176,1)', 'rgba(14,197,210,1)']
        },
        energyObj: {
          energyConsumption: 0.0,
          power: 0.0
        },
        energyList: {
          margin: '0px auto 0',
          height: '280px',
          gridTop: '22%',
          xSplitColor: '#014778',
          ySplitColor: '#014778',
          axisLabel: {
            fontSize: 12
          },
          formatter: true,
          yAxisName: '功率 单位：w',
          dw: 'w',
          markLineName: '电能监测阈值',
          gridLeft: '0%',
          gridRight: '0%',
          markLineOpacity: 0,
          markLineShow: false,
          xData: [],
          data: []
        },
        energy24Obj: {
          deviceId: '',
          date: dayjs().format('YYYY-MM-DD')
        },
        waveList: {
          margin: '0px auto 0',
          height: '280px',
          gridTop: '22%',
          xSplitColor: '#014778',
          ySplitColor: '#014778',
          axisLabel: {
            fontSize: 12
          },
          yAxisName: '单位：t',
          dw: 't',
          xData: [],
          data: []
        },
        water24obj: {
          deviceId: '',
          date: dayjs().format('YYYY-MM-DD')
        },
        currentPos: {},
        showEnergyTag: false,
        showType: 0,
        exceptionList: [],
        page: 1,
        pageSize: 11,
        total: 10,
        time: dayjs().format('YYYY-MM-DD'),
        exceptionType: '06', // 06电耗，07水耗
        settingArr: []
      }
    },
    mounted() {
      this.getWebEnergy()
      this.getWebWater()
      this.getDefaultDeviceList()
      window.getWaterElec = () => {
        if (this.showEnergyTag && this.time === dayjs().format('YYYY-MM-DD')) this.getExceptionEnergyTotal(this.deptId, this.exceptionType, this.page, this.pageSize, this.time)
      }
    },
    methods: {
      /**
       * 能量设备初始化列表
       * @author wanghongling
       * @createTime 2019/07/19
       * @returns {string}
       */
      getDefaultDeviceList() {
        return this.$request.deviceDefaultList({departmentId: this.deptId}).then(res => {
          console.log('能量设备初始化列表', res)
          this.energyObj.power = res.totalPowerModel.currPower
          this.energyObj.energyConsumption = res.totalPowerModel.currTotalEnergyConsumption
          this.water24obj.todayWater = res.totalWaterModel.todayWater
          this.water24obj.yesterdayWater = res.totalWaterModel.yesterdayWater
        }).catch(e => {
          console.error(e)
        })
      },
      /**
       * 切换分页
       * @author wanghongling
       * @param currentPage 当前页
       * @areateTime 2019/06/25
       */
      pageChange (currentPage) {
        this.page = currentPage
        this.getExceptionEnergyTotal(this.deptId, this.exceptionType, this.page, this.pageSize, this.time)
      },
      /**
       * 切换时间查看能耗
       * @author wanghongling
       * @param val 选中的时间
       * @areateTime 2019/06/25
       */
      changeTime(val) {
        this.time = val
        this.page = 1
        this.getExceptionEnergyTotal(this.deptId, this.exceptionType, this.page, this.pageSize, val)
        if (this.showType === 0) {
          this.getEnergy24(this.deptId, val)
        } else {
          this.getWaterAll24(this.deptId, val)
        }
      },
      /**
       * 获取实时的能耗
       * @author wanghongling
       * @areateTime 2019/06/25
       */
      getWebEnergy() {
        window.getEnergy = e => {
          if (e.content.departmentId === this.deptId) {
            this.energyObj = e.content
            if (this.showEnergyTag && this.time === dayjs().format('YYYY-MM-DD')) this.getEnergy24(this.deptId, this.time)
          }
        }
      },
      /**
       * 获取实时的耗水
       * @author wanghongling
       * @areateTime 2019/06/25
       */
      getWebWater() {
        window.getWater = e => {
          if (e.content.departmentId === this.deptId) {
            this.water24obj = e.content
            if (this.showEnergyTag && this.time === dayjs().format('YYYY-MM-DD')) this.getWaterAll24(this.deptId, this.time)
          }
        }
      },
      /**
       * 获取电能异常监测设置信息列表
       * @author wanghongling
       * @areateTime 2019/06/25
       * @param departmentId 食堂id
       */
      getEnergySettingElec(departmentId) {
        return this.$request.energySettingElecGet({departmentId}).then(res => {
          console.log('获取的电能监测阈值', res)
          let arr = []
          if (!this.$utils.isEmptyObject(res)) {
            res.map(v => {
              let obj = {
                beginTime: v.beginTime,
                endTime: v.endTime,
                powerPeakUpper: v.powerPeakUpper
              }
              arr.push(obj)
            })
            return arr
          } else {
            return arr
          }
        }).catch(e => {
          console.error(e)
        // this.$superMessage('提示', e)
        })
      },
      /**
       * 获取24小时总能耗
       * @author wanghongling
       * @param departmentId 食堂id
       * @param monltorTime 时间
       */
      async getEnergy24(departmentId, monltorTime) {
        this.settingArr = await this.getEnergySettingElec(departmentId)
        this.$request.deviceElectricAll24Get({departmentId, monltorTime}).then(res => {
          console.log('获取24小时总能耗', res)
          this.energyList.markLineName = '电能监测阈值'
          if (this.settingArr.length === 0) {
            this.energyList.markLineOpacity = 0
            this.energyList.markLineShow = false
          } else {
            this.energyList.markLineOpacity = 1
            this.energyList.markLineShow = true
          }
          this.$set(this.energyList, 'settingArr', this.settingArr)
          this.$set(this.energyList, 'xData', res.dataKey)
          this.$set(this.energyList, 'data', res.powerValue)
          this.$set(this.currentPos, 'currDate', res.currDate)
          this.$set(this.currentPos, 'currPower', res.currPower)
          this.$set(this.currentPos, 'currTotalEnergyConsumption', res.currTotalEnergyConsumption)
        }).catch(e => {
          console.log(e)
        })
      },
      /**
       * 24小时用水变化
       * @author wanghongling
       * @param departmentId 食堂id
       * @param monltorTime 时间
       */
      getWaterAll24(departmentId, monltorTime) {
        this.$request.deviceWaterAll24Get({departmentId, monltorTime}).then(res => {
          console.log('获取24小时用水变化', res)
          this.waveList.xData = res.dateKey
          this.waveList.data = res.dateValue
          this.$set(this.currentPos, 'currDate', res.currDate)
          this.$set(this.currentPos, 'todayWater', res.todayWater)
          this.$set(this.currentPos, 'yesterdayWater', res.yesterdayWater)
        }).catch(e => {
          console.log(e)
        // this.$superMessage('提示', e)
        })
      },
      /**
       * 获取食堂总能耗异常记录(06电，07水)
       * @author wanghongling
       * @createTime 2019/07/31
       * @param departmentId 食堂id
       * @param exceptionType 异常类型(06电，07水)
       * @param page 页码
       * @param pageSize 每页个数
       * @param time 时间
       */
      getExceptionEnergyTotal(departmentId, exceptionType, page, pageSize, time) {
        this.$request.exceptionEnergyTotalListGet({departmentId, exceptionType, page, pageSize, time}).then(res => {
          if (!this.$utils.isEmptyObject(res)) {
            console.log('获取食堂总能耗异常记录(06电，07水)', res)
            this.exceptionList = res.resultList
            this.total = res.totalCount
          }
        }).catch(e => {
          console.log(e)
        // this.$superMessage('提示', e)
        })
      },
      /**
       * 展示24小时总能耗信息(06电，07水)
       * @param cur 当前信息
       * @param num 类型
       * @returns {string}
       */
      showMsg (cur, num) {
        this.showType = num
        this.exceptionType = (this.showType === 0) ? '06' : '07'
        cur.date = dayjs().format('YYYY-MM-DD')
        this.time = dayjs().format('YYYY-MM-DD')
        this.currentPos = cur
        this.showEnergyTag = true
        this.getExceptionEnergyTotal(this.deptId, this.exceptionType, this.page, this.pageSize, this.time)
        if (num === 0) {
          console.log('电')
          this.$nextTick(() => {
            this.getEnergy24(this.deptId, cur.date)
          })
        } else {
          console.log('水费')
          this.$nextTick(() => {
            this.getWaterAll24(this.deptId, cur.date)
          })
        }
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';
  .energy-wrap{
    position: relative;
    .energy{
      display: flex;
      align-items: center;
      justify-content: space-around;
      .energy-item{
        flex: 1;
        background-color: rgba(8,129,143,0.1);
        display: flex;
        height: 115px;
        align-items: center;
        color: @lightBlue;
        font-size: 14px;
        cursor: pointer;
        &-left{
          width: 95px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &-right{
          text-align: center;
          p:nth-child(3) {
            padding-top: 8px;
          }
        }
        .white{
          color: #fff;
        }
        .fz18{
          font-size: 18px;
        }
        .fz12{
          font-size: 12px;
        }
      }
      /*.energy-item:first-child{*/
        /*margin-right: 15px;*/
      /*}*/
      .energy-item:last-child{
        margin-left: 15px;
      }
    }
    .wave-class{
      flex: 1;
      padding-right: 20px;
      width: 100%;
    }
    .gl{
      display: flex;
      margin-bottom: 5px;
      &-left{
        margin-right: 30px;
      }
      &-left, &-right{
        font-size: 14px;
        display: flex;
        span{
          color: #00d6ff;
        }
        span:last-child{
          padding-left: 5px;
          color: #13ff00;
        }
      }
    }
    ul.open-his1{
      width: 300px;
      background: #012747;
      .his-title{
        font-size: 15px;
        color: @lightBlue;
        text-align: center;
        padding: 5px;
      }
      .li{
        margin-bottom: 5px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        &-left{
          font-size: 14px;
          color: #00d6ff;
        }
        &-right{
          color: #0aaade;
          font-size: 12px;
          text-align: right;
        }
      }
      /*分页样式*/
      .el-pagination{
        text-align: center;
        margin-bottom: 6px;
      }
      .el-pagination.is-background .el-pager li {
        background-color: inherit;
        color: #0aaade;
        margin: 0;
        font-size: 14px;
        font-weight: normal;
      }
      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev{
        background: inherit;
        color: #0aaade;
        margin: 0;
      }
      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #004270 !important;
        color: #00ffff;
      }
    }
    .wave-bar1{
      position: absolute;
      left: 470px;
      bottom: 5px;
    }
    .sd-ct{
      position: absolute;
      top: 14px;
      left: 19.5px;
      width: 95px;
      z-index: 1;
      height: 100%;
      align-items: center;
      justify-content: center;
      display: flex;
      img{
        transform: scale(1.1);
      }
    }
    .img-zindex{
      z-index: 2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/energy.vue